import React, { useState } from 'react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '../../ui/dropdown-menu';

/**
 * A button that opens a searchable single-pick menu (Radix, z 1000 — above
 * the side panel). Picking calls onPick(value) and closes.
 *
 *   options [{ value, label, hint? }]
 *   onQueryChange(q) — optional: remote search (parent updates options)
 */
export default function PickerMenu({
  children,
  options = [],
  onPick,
  searchPlaceholder = 'Search',
  emptyText = 'No matches',
  loading = false,
  onQueryChange,
  triggerClassName = 'ak-btn',
  ariaLabel,
  disabled,
  align = 'start',
  onOpenChange,
}) {
  const [q, setQ] = useState('');
  const local = !onQueryChange;
  const needle = q.trim().toLowerCase();
  const shown = local && needle
    ? options.filter((o) => `${o.label} ${o.hint || ''}`.toLowerCase().includes(needle))
    : options;

  const update = (value) => {
    setQ(value);
    if (onQueryChange) onQueryChange(value);
  };

  return (
    <DropdownMenu onOpenChange={(open) => { if (!open) update(''); if (onOpenChange) onOpenChange(open); }}>
      <DropdownMenuTrigger asChild disabled={disabled}>
        <button type="button" className={triggerClassName} aria-label={ariaLabel} disabled={disabled}>
          {children}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align={align} className="min-w-[260px] max-w-[360px]">
        <div className="ak-menu-search">
          <input
            value={q}
            placeholder={searchPlaceholder}
            aria-label={searchPlaceholder}
            onChange={(e) => update(e.target.value)}
            onKeyDown={(e) => { if (e.key !== 'Escape' && e.key !== 'ArrowDown') e.stopPropagation(); }}
          />
        </div>
        <div className="ak-menu-list" role="presentation">
          {loading ? <div className="ak-muted us-menu-note">Searching…</div> : null}
          {!loading && shown.map((o) => (
            <DropdownMenuItem key={String(o.value)} onSelect={() => onPick(o.value)} disabled={o.disabled}>
              <span className="us-menu-label">{o.label}</span>
              {o.hint ? <span className="ak-muted us-menu-hint">{o.hint}</span> : null}
            </DropdownMenuItem>
          ))}
          {!loading && shown.length === 0 ? <div className="ak-muted us-menu-note">{emptyText}</div> : null}
        </div>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
